module.exports = __webpack_public_path__ + "img/4_135.9a67d6a8.png";